"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTextArea = exports.FormSelect = exports.FormPasswordInput = exports.FormNumberInput = exports.FormInput = exports.FormIconInput = exports.FormDatePicker = void 0;

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _ = require("./..");

var _hooks = require("../../../hooks");

var FormSelect = (0, _hooks.withFormState)(_atoms.Select);
exports.FormSelect = FormSelect;
var FormInput = (0, _hooks.withFormState)(_atoms.Input);
exports.FormInput = FormInput;
var FormTextArea = (0, _hooks.withFormState)(_atoms.TextArea);
exports.FormTextArea = FormTextArea;
var FormIconInput = (0, _hooks.withFormState)(_molecules.IconInput);
exports.FormIconInput = FormIconInput;
var FormPasswordInput = (0, _hooks.withFormState)(_atoms.PasswordInput);
exports.FormPasswordInput = FormPasswordInput;
var FormNumberInput = (0, _hooks.withFormState)(_atoms.NumberInput);
exports.FormNumberInput = FormNumberInput;
var FormDatePicker = (0, _hooks.withFormState)(_.DatePicker);
exports.FormDatePicker = FormDatePicker;